import React, { FC } from 'react';
import Bike from '../organisms/Bike';
import Configuration from '../organisms/Configuration';
import NavigationSteps from '../organisms/NavigationSteps';
import EditOrderFooter from '../organisms/EditOrderFooter';
import Logo from '../atoms/Logo';
import Header from '../organisms/Header';
import { Container, Wrapper, BikeWrapper } from './Configurator';

interface EditOrderConfiguratorProps {
  productId: number;
}

// Configurator for editing an existing order. It has a different footer, where the 
// configuration can be saved to the order that is being edited
const EditOrderConfigurator: FC<EditOrderConfiguratorProps> = ({
  productId,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <div>
        <Container>
          <Wrapper>
            <Header>
              <Logo />
            </Header>
            <BikeWrapper>
              <Bike productId={productId} />
            </BikeWrapper>
          </Wrapper>
          <NavigationSteps productId={productId} hideProducts />
        </Container>
        <Configuration productId={productId} hideProducts hideBottomButton />
      </div>
      <EditOrderFooter productId={productId} />
    </div>
  );
};

export default EditOrderConfigurator;
